import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthActionEnum } from './index';
import { AuthenticateUserSuccessAction } from '..';
import { AuthenticationService } from '../../Authentication/AuthenticationService';
import { AuthenticateUserFailureAction } from './ActionCreator';

export const authenticateUserEpic = (action$: any) =>
  action$.pipe(
    ofType(AuthActionEnum.AuthenticateUser),
    switchMap(() => {
      // Use OIDC AuthenticationService to get user info
      return from(AuthenticationService.Instance.getUser());
    }),
    map((user: { token: string | undefined; email: string | undefined; username: string | undefined }) => {
      const isAuthenticated = Boolean(user.token);
      return AuthenticateUserSuccessAction(isAuthenticated);
    }),
    catchError((x) => {
      console.error('[AuthEpic] Authentication error:', x);
      return of(AuthenticateUserFailureAction('Error authenticating user.'));
    })
  );
